import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Heading from "./Heading";
import { useState } from "react";

export default function ContactUs() {
  const [isChecked, setIsChecked] = useState(true);
  const [isCheck, setIsCheck] = useState(false);
  const navigate = useNavigate();

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    if (!event.target.checked) {
      setIsCheck(false);
    }
  };

  const handleBackButton = (event) => {
    event.preventDefault();
    navigate("/login");
  };

  const handleCheckboxChange1 = (event) => {
    setIsCheck(event.target.checked);
  };

  return (
    <>
      <Heading />
      <div className="container">
        <div className="card my-3 mx-auto">
          <div
            className="card-header bg-white text-black"
            style={{ fontSize: "25px" }}
          >
            <b>Contact Us</b>
          </div>
          <div className="card-body">
            <div className="row">
              <div
                className="col-12 col-md-5 mb-3 col-lg-5"
                style={{ fontSize: "20px" }}
              >
                <b>Query Type</b>
              </div>
              <div
                className="col-12 col-md-7 mb-3"
                style={{ fontSize: "20px" }}
              >
                <b>How to Contact?</b>
              </div>

              <div
                className="col-12 col-md-5 mt-2"
                style={{ fontSize: "18px" }}
              >
                Login or First time Registration related issues or any technical
                issues.
              </div>
              <div
                className="col-12 col-md-7 mt-2"
                style={{ fontSize: "18px" }}
              >
                {isChecked && (
                  <>
                    <a
                      target="_blank"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSfc-XdUcuTuADi0X6Pl1d10Uqh6SuR_QqPyRGmkVL0ltBOJyw/viewform"
                      style={{ textDecoration: "none" }}
                    >
                      <b>Click here to submit your query.</b>
                    </a>
                    <br />
                    <span className="text-danger">
                      <b>
                        Please make sure you enter below details while raising
                        the request
                      </b>
                    </span>
                    <ul>
                      <li>Group D CET registration number</li>
                      <li>Name of the candidate</li>
                      <li>
                        Details of the issue, along with relevant screenshots.
                      </li>
                    </ul>
                    {/* <hr className="w-100" />
                    <div className="d-flex">
                      If your question hasn't been answered yet?
                    <input
                      className="ms-3"
                      type="checkbox"
                      checked={isCheck}
                      onChange={handleCheckboxChange1}
                    />
                    </div>
                    <br />
                    {isCheck && (
                      <>
                        Please feel free to call us at the numbers provided if
                        your question is still unanswered.
                        <br />
                        Phone - 18005728997 (on all working days from 10 AM to 5
                        PM)
                        <br />
                        Phone - 7428944699 (For technical issues on all working
                        days from 9 AM to 6 PM)
                        <br />
                        <br />
                      </>
                    )} */}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center mb-5">
          <button
            className="btn btn-success text-white"
            onClick={handleBackButton}
          >
            {"Back"}
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
}
